/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioTypeV2 {
    REAL_TIME = 'REAL_TIME',
    POST_EVENT = 'POST_EVENT',
    PERIODIC = 'PERIODIC',
    PERIODIC_ENTITY = 'PERIODIC_ENTITY'
}


export function instanceOfInternalApiScenarioTypeV2(value: any): boolean {
    for (const key in InternalApiScenarioTypeV2) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioTypeV2, key)) {
            if (InternalApiScenarioTypeV2[key as keyof typeof InternalApiScenarioTypeV2] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioTypeV2FromJSON(json: any): InternalApiScenarioTypeV2 {
    return InternalApiScenarioTypeV2FromJSONTyped(json, false);
}

export function InternalApiScenarioTypeV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioTypeV2 {
    return json as InternalApiScenarioTypeV2;
}

export function InternalApiScenarioTypeV2ToJSON(value?: InternalApiScenarioTypeV2 | null): any {
    return value as any;
}

export function InternalApiScenarioTypeV2ToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioTypeV2 {
    return value as InternalApiScenarioTypeV2;
}

